import BaseUI from "../../../core/src/ui/BaseUI";
import { UIStates, UIModes } from "../../../core/src/ui/UIStates";
import ViewManager from "../../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import { UIButtons } from "../../../core/src/ui/UIButtons";
import { Commands } from "../../../core/src/commands/CommandEnum";
import { UIUpdateEvent } from "../../../core/src/ui/UIUpdateEvents";
import { UIComponents } from "../../../core/src/ui/UIComponents";
import SpinModel from "../../../core/src/model/SpinModel";
import BetModel from "../../../core/src/model/BetModel";
import SoundVars from "../../../core/src/const/SoundVars";
import TextField from "../../../core/src/views/components/TextField";
import AutoplayModel from "../../../core/src/model/AutoplayModel";
import BangUp from "../../../core/src/utils/BangUp";
import GameModel from "../../../core/src/model/GameModel";
import PromotionalFreeGamesModel from "../../model/PromotionalFreeGamesModel";
import { VendorCommandsEnum } from "../../commands/VendorCommandsEnum";
import CommandManager from "../../../core/src/commands/CommandManager";
import ConfigManager from '../../../core/src/managers/ConfigManager';
import { ConfigurationTypes } from '../../../core/src/const/ConfigurationTypes';
import Configs from "../../vendorConfigs/Configs";
import { VendorUIComponents } from "../ui/VendorUIComponents";
import { MoneyField } from "../../../core/src/views/MoneyField";
import SceneView from '../../../core/src/views/SceneView';

export default class UIDesktop extends BaseUI {
    protected autoSpinCounts: TextField;
    protected autoplayDisable: boolean;
    protected bottomScene: SceneView;
    public create(): void {
        this.autoplayDisable = Configs.game.clientConfig.autoplayDisable;
        super.create();
        this.scene = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
        this.bottomScene = ViewManager.getLayer(DefaultLayers.BetBarBottom).setScene();
        this.scene.buttons.forEach((btn) => {
            this.buttons.push(btn);
            this.elements.push(btn);
        });
        this.bottomScene.buttons.forEach((btn) => {
            this.buttons.push(btn);
            this.elements.push(btn);
        });
        this.autoSpinCounts = this.scene.sceneTextFields.get(
            "autoCount"
        ) as TextField;
        this.assignInterraction(
            Commands.SPIN,
            this.scene.buttons.get(UIButtons.Spin)
        );
        this.assignInterraction(
            Commands.STOP_AUTOPLAY,
            this.scene.buttons.get(UIButtons.StopAutoplay),
        );
        if (!this.autoplayDisable) {
            this.assignInterraction(
                Commands.TOGGLE_AUTOPLAY_POPUP,
                this.scene.buttons.get(UIButtons.AutoPlay),
                SoundVars.BUTTON_CLICK,
                false,
            );
        }
        if (!Configs.game.clientConfig.disableBuyFeature
             && Configs.buyFeature?.maxFeaturePurchasePrice) {
            this.assignInterraction(
                Commands.TOGGLE_BUY_FEATURE,
                this.scene.buttons.get(UIButtons.FeatureBuy),
                SoundVars.BUTTON_CLICK
            );
        }
        this.addSpecificFeatureElement();

        //    this.assignInterraction(Commands.TOGGLES_S, this.scene.buttons.get(UIButtons.StopAutoplay), SoundVars.BUTTON_CLICK);
        this.setSettingsBtnInteraction();
        this.assignInterraction(
            [
                Commands.TOGGLE_MASTER_SOUND,
                VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
            ],
            this.bottomScene.buttons.get(UIButtons.SoundMuted),
            SoundVars.BUTTON_CLICK,
            "uiSoundBtn"
        );
        this.assignInterraction(
            [
                Commands.TOGGLE_MASTER_SOUND,
                VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
            ],
            this.bottomScene.buttons.get(UIButtons.Sound),
            SoundVars.BUTTON_CLICK,
            "uiSoundBtn"
        );
        this.assignInterraction(
            Commands.TOGGLE_BET_POPUP,
            this.scene.buttons.get(UIButtons.Bet),
            SoundVars.BUTTON_CLICK,
            false
        );
        if (GameModel.canSkipSpin()) {
            this.assignInterraction(
                Commands.SKIP,
                this.scene.buttons.get(UIButtons.Stop)
            );
        }

        if (this.scene.buttons.has(UIButtons.Turbo) && Configs.game.clientConfig.quickStop) {
            this.assignInterraction(
                Commands.TOGGLE_TURBO_SPIN,
                this.scene.buttons.get(UIButtons.Turbo)
            );
        }

        CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON);

        this.setBehaviours();
        this.setBonusMode();
        this.setAutoMode();
        this.setFreeSpinsMode();
        this.setPromotionBehaviours();
        // TODO think of having a config for that
    }

    protected setSettingsBtnInteraction() {
        this.assignInterraction(
            [Commands.TOGGLE_SETTINGS],
            this.scene.buttons.get(UIButtons.Settings),
            SoundVars.BUTTON_CLICK,
            true
        );
    }

    protected addSpecificFeatureElement() {

    }

    public update(event: UIUpdateEvent, props?: any): void {
        if (this.scene && this.bottomScene) {
            switch (event) {
                case UIUpdateEvent.TempWin:
                    this.bottomScene.sceneMoneyFields.get(UIComponents.WinAlternative).value =
                        SpinModel.tempWinAmount;
                    break;
                case UIUpdateEvent.Balance:
                    this.bottomScene.sceneMoneyFields.get(
                        UIComponents.BalanceAlternative
                    ).value = BetModel.getCurrentBalance();

                    if (this.autoSpinCounts) {
                        let test = AutoplayModel.autoSpinNum;
                        if (AutoplayModel.autoSpinNum >= 0 && !SpinModel.inFreegames()) {
                            this.autoSpinCounts.text =
                                AutoplayModel.isAutoSpinActive()
                                    ? AutoplayModel.getAutoSpinNum().toString()
                                    : "0";
                        } else {
                            this.autoSpinCounts.text = '';
                        }
                    } else {
                        this.warnForMissingElement("autoSpinCounts");
                    }
                    break;
                case UIUpdateEvent.Bet:
                    this.bottomScene.sceneMoneyFields.get(
                        UIComponents.TotalBetAlternative
                    ).value = BetModel.totalBet;
                    break;
                case UIUpdateEvent.ClearWin:
                    this.bottomScene.sceneMoneyFields.get(UIComponents.WinAlternative).value = 0;
                    break;
                case UIUpdateEvent.Win:
                    this.bottomScene.sceneMoneyFields.get(UIComponents.WinAlternative).value =
                        props ? props.win : SpinModel.getAccumulatedWin();
                    break;
                case UIUpdateEvent.Bangup_win:
                    let winField = this.bottomScene.sceneMoneyFields.get(
                        UIComponents.WinAlternative
                    );
                    let bangup = new BangUp();
                    bangup.startBangup(
                        winField.value,
                        SpinModel.getAccumulatedWin(),
                        0.5,
                        {},
                        (val) => {
                            winField.value = val;
                        },
                        () => {
                            bangup = null;
                        }
                    );
                    break;
                case UIUpdateEvent.FreeGames:
                    this.autoSpinCounts.text = "";
                    break;
                case UIUpdateEvent.FreeSpins:
                    this.bottomScene.sceneMoneyFields.get(UIComponents.FreeSpinsAlternative).value =
                    SpinModel.accumulatedWin || 0;
                    break;
                case UIUpdateEvent.ClearFreeSpins:
                    this.bottomScene.sceneMoneyFields.get(
                        UIComponents.FreeSpinsAlternative
                    ).value = 0;
                    break;
                case UIUpdateEvent.All:
                    this.bottomScene.sceneMoneyFields.get(
                        UIComponents.BalanceAlternative
                    ).value = BetModel.getCurrentBalance();

                    this.bottomScene.sceneMoneyFields.get(
                        UIComponents.TotalWinAlternative
                    ).value = BetModel.totalBet;

                    this.bottomScene.sceneMoneyFields.get(UIComponents.WinAlternative).value =
                        SpinModel.getCurrentWin();

                    this.autoSpinCounts.text = "";
                    this.bottomScene.sceneTextFields.get(
                        UIComponents.FreeSpinsAlternative
                    ).text = PromotionalFreeGamesModel.freeGamesCount
                            ? PromotionalFreeGamesModel.freeGamesCount.toString()
                            : "";
                    break;
                case UIUpdateEvent.Autoplay:
                    if (AutoplayModel.isAutoSpinActive() && AutoplayModel.getAutoSpinNum() > 0) {
                        this.autoSpinCounts.text = String(AutoplayModel.getAutoSpinNum());
                    } else {
                        this.autoSpinCounts.text = "0";
                    }

                    break;
            }
        }
    }
    protected setFreeSpinsMode() {
        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.bottomScene.buttons.get(UIButtons.Sound)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.bottomScene.buttons.get(UIButtons.SoundMuted)),
            1
        );

        let isBuyFeature = false;
        if (!Configs.game.clientConfig.disableBuyFeature
             && Configs.buyFeature?.maxFeaturePurchasePrice) {
            isBuyFeature = true;
        } else {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.FeatureBuy)),
                1
            );
        }
        if (this.scene.buttons.has(UIButtons.Turbo)) {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }

        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToHide: [
                    ...bonusBts,
                    this.autoSpinCounts,
                    this.bottomScene.groups.get(VendorUIComponents.BottomElementsGroup),
                    this.scene.groups.get(VendorUIComponents.BuyFeatureGroup)
                ],
                uiToEnable: [this.scene.buttons.get(UIButtons.Settings)]
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Bet),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.Turbo),
                    this.scene.sceneTextFields.get("win") as TextField,
                    this.bottomScene.sceneMoneyFields.get(UIComponents.WinAlternative) as MoneyField
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
                uiToEnable: [GameModel.canSkipSpin(), this.scene.buttons.get(UIButtons.Settings)]
                ? [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.bottomScene.buttons.get(UIButtons.Sound)
                ]
                : [
                    this.bottomScene.buttons.get(UIButtons.Sound)
                ],
                uiToShow: [
                    this.bottomScene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    this.scene.buttons.get(UIButtons.Settings)
                ],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.Settings)],
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.PICKSCREEN,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                    this.scene.buttons.get(UIButtons.Settings),
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.FREE_SPINS
        );
    }

    protected setBonusMode() {
        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.bottomScene.buttons.get(UIButtons.Sound)),
            1
        );
        // bonusBts.splice(
        //     bonusBts.indexOf(this.scene.buttons.get("sound_muted")),
        //     1
        // );
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToHide: [...bonusBts,this.autoSpinCounts],
            },
            UIModes.BONUS
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.BONUS
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.BONUS
        );
        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.BONUS
        );
    }

    protected setBehaviours() {
        let idleButtons = [...this.buttons];
        if (
            GameModel.gameConfig.disableAutoplay &&
            idleButtons.includes(this.scene.buttons.get(UIButtons.AutoPlay))
        ) {
            idleButtons.splice(
                idleButtons.indexOf(this.scene.buttons.get(UIButtons.AutoPlay)),
                1
            );
        }
        let isBuyFeature = false;
        if (
            ConfigManager.hasConfig(ConfigurationTypes.GAME)
            && (!Configs.game.clientConfig.disableBuyFeature
            && Configs.buyFeature?.maxFeaturePurchasePrice)
        ) {
            isBuyFeature = true;
        } else {
            if (idleButtons.includes(this.scene.buttons.get(UIButtons.FeatureBuy))) {
                idleButtons.splice(
                    idleButtons.indexOf(this.scene.buttons.get(UIButtons.FeatureBuy)),
                    1
                );
            }
        };
        let activateTurbo: boolean = Configs.game.clientConfig.quickStop;
        if (!activateTurbo) {
            idleButtons.splice(
                idleButtons.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        };
        this.setBehaviour(UIStates.IDLE, {
            uiToEnable: idleButtons,
            uiToDisable: this.autoplayDisable
                ? [
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ]
                : [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            uiToShow: [
                this.scene,
                this.bottomScene,
                isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                this.scene.buttons.get(UIButtons.Spin),
                this.autoplayDisable ? null : this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.Bet),
                this.bottomScene.groups.get(VendorUIComponents.BottomElementsGroup),
                activateTurbo ? this.scene.buttons.get(UIButtons.Turbo) : null,
                this.scene.sceneTextFields.get("win") as TextField,
                this.bottomScene.sceneMoneyFields.get(UIComponents.WinAlternative) as MoneyField
            ],
            uiToHide: [
                this.autoSpinCounts,
                this.autoplayDisable ? this.scene.buttons.get(UIButtons.AutoPlay) : null,
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
                this.bottomScene.groups.get(UIComponents.FreeGamesInfoGroup),
                this.bottomScene.groups.get(UIComponents.FreeSpinsInfoGroup),
                isBuyFeature ? null : this.scene.groups.get(VendorUIComponents.BuyFeatureGroup),
                activateTurbo ? null : this.scene.buttons.get(UIButtons.Turbo),
            ],
        });
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
                this.scene.buttons.get(UIButtons.Turbo),
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                activateTurbo ? this.scene.buttons.get(UIButtons.Turbo) : null,
            ],
            uiToEnable: GameModel.canSkipSpin()
            ? [
                this.scene.buttons.get(UIButtons.Stop),
                this.bottomScene.buttons.get(UIButtons.Sound)
            ]
            : [
                this.bottomScene.buttons.get(UIButtons.Sound)
            ],
        });
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
            uiToEnable: GameModel.canSkipSpin()
                ? [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.bottomScene.buttons.get(UIButtons.Sound)
                ]
                : [
                    this.bottomScene.buttons.get(UIButtons.Sound)
                ],
            uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.SPIN_END, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.STOP_SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.bottomScene.buttons.get(UIButtons.Sound)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.bottomScene.buttons.get(UIButtons.SoundMuted)),
            1
        );
        if (activateTurbo && this.scene.buttons.has(UIButtons.Turbo)) {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }
        this.setBehaviour(UIStates.AUTO, {
            uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
            uiToShow: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet)
            ],
            uiToDisable: [
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Settings)
            ],
        });

        this.setBehaviour(UIStates.HIDDEN, {
            uiToHide: [this.scene, this.bottomScene],
        });

        this.setBehaviour(UIStates.PICKSCREEN, {
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
                isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                this.scene.buttons.get(UIButtons.Settings),
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ]
        })
    }
    protected setAutoMode() {
        let isBuyFeature = false;
        if (!Configs.game.clientConfig.disableBuyFeature
            && Configs.buyFeature?.maxFeaturePurchasePrice) {
            isBuyFeature = true;
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.bottomScene.groups.get(VendorUIComponents.BottomElementsGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.bottomScene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                ],
            },
            UIModes.AUTO
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToShow: [
                    this.bottomScene.groups.get(VendorUIComponents.BottomElementsGroup)],
                uiToDisable: this.buttons,
                uiToHide: [this.bottomScene.groups.get(UIComponents.FreeSpinsInfoGroup)]
            },
            UIModes.AUTO
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToShow: [
                    this.bottomScene.groups.get(VendorUIComponents.BottomElementsGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.bottomScene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                ],
                uiToEnable: [
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.bottomScene.buttons.get(UIButtons.Sound)
                ]
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.autoSpinCounts,
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.AUTO,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                ]
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.PICKSCREEN,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                    this.scene.buttons.get(UIButtons.Settings),
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.AUTO
        );
    }

    protected setPromotionBehaviours() {
        let isBuyFeature = false;
        if (!Configs.game.clientConfig.disableBuyFeature
            && Configs.buyFeature?.maxFeaturePurchasePrice) {
            isBuyFeature = true;
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.Spin)],
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.bottomScene.groups.get(UIComponents.FreeGamesInfoGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.autoSpinCounts,
                    this.bottomScene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    isBuyFeature ? this.scene.groups.get(VendorUIComponents.BuyFeatureGroup) : null,
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: this.buttons,
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
                uiToEnable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.PROMOTION_SPINS
        );
    }
}
